<template>
  <div class="main-wrapper testimonials-page innerpagebg">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div
            class="col-12 col-sm-12 col-md-6 col-lg-4"
            v-for="record in Testimonials"
            :key="record.id"
          >
            <!-- Testimonials Item -->
            <div class="testimonial-group">
              <div class="testimonial-review">
                <div class="rating-point">
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled ms-1"></i>
                  <i class="fas fa-star filled ms-1"></i>
                  <i class="fas fa-star filled ms-1"></i>
                  <i class="fas fa-star filled ms-1"></i>
                  <span> 5.0</span>
                </div>
                <h5>Finibus mauris. Aliquam consectetur</h5>
                <p>
                  {{ record.Topic }}
                </p>
              </div>
              <div class="listing-venue-owner">
                <a class="navigation">
                  <img
                    :src="require(`@/assets/img/profiles/${record.Image}`)"
                    alt="User"
                  />
                </a>
                <div class="testimonial-content">
                  <h5>{{ record.Name }}</h5>
                  <a href="javascript:void(0);" class="btn btn-primary">
                    {{ record.Sports }}
                  </a>
                </div>
              </div>
            </div>
            <!-- /Testimonials Item -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import Testimonials from "@/assets/json/testimonials.json";
export default {
  data() {
    return {
      Testimonials: Testimonials,
      title: "Testimonials Grid",
      text: "Home",
      text1: "Testimonials Grid",
    };
  },
};
</script>
